export default __webpack_public_path__ + "static/media/round_spa.08124c4e.svg";